import { Stack, Text, useTheme } from "@bps/fluent-ui";
import { ClaimManagementModalFormLabels } from "@modules/acc/screens/claim/components/ClaimFormEnums.ts";
import { convertClinicalSideToDiagnosisSide } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/active-condition-list/active-condition-list.utils.ts";
import { getDiagnosisText } from "@stores/acc/utils/acc.utils.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";

interface DiagnosisDetailsProps {
  episodeOfCare: EpisodeOfCare | undefined;
}

const DiagnosisDetailsBase: React.FC<DiagnosisDetailsProps> = ({
  episodeOfCare
}) => {
  const { acc } = useStores();
  const theme = useTheme();
  const primaryDiagnosis = episodeOfCare?.primaryDiagnosis;
  const diagnosisSide = episodeOfCare?.diagnosisSide;
  const additionalDiagnosesText = episodeOfCare?.claim?.dto?.claimDiagnosis
    ?.filter(item => item.terminology?.text !== primaryDiagnosis)
    .map(item => getDiagnosisText(item, acc))
    .join(", ");

  return (
    <Stack
      styles={{
        root: {
          border: "1px solid",
          borderColor: theme.palette.neutralLight,
          padding: "8px 16px",
          marginTop: 8
        }
      }}
      tokens={{ childrenGap: 8 }}
    >
      <Stack tokens={{ childrenGap: 4 }}>
        <Text
          variant="xSmall"
          styles={{ root: { color: theme.palette.neutralSecondary } }}
        >
          {ClaimManagementModalFormLabels.primaryDiagnosis}
        </Text>
        <Text>
          {primaryDiagnosis}
          {convertClinicalSideToDiagnosisSide(diagnosisSide)}
        </Text>
      </Stack>
      {additionalDiagnosesText && (
        <Stack tokens={{ childrenGap: 4 }}>
          <Text
            variant="xSmall"
            styles={{ root: { color: theme.palette.neutralSecondary } }}
          >
            {ClaimManagementModalFormLabels.additionalDiagnosis}
          </Text>
          <Text>{additionalDiagnosesText}</Text>
        </Stack>
      )}
    </Stack>
  );
};

export const DiagnosisDetails = withFetch(
  ({ acc }) => [acc.ref.diagnosisSides.load()],
  DiagnosisDetailsBase
);
